import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
  GET_CURRENT_WEEKSTAAT: {
    url: "weekstaat",
    method: "get",
  },
  DOWNLOAD_REPORT: (id) => ({
    url: `weekstaat/download-report/${id}/weekstaat`,
    method: "get",
  }),
  WEEKSTAAT_DOWNLOAD: {
    url: "document",
    method: "get",
  },
};

export const useCurrentWeekstaat = () =>
  useApiFetcherSWR(API_ENDPOINT.GET_CURRENT_WEEKSTAAT);

export const useDownloadWeekstaatReport = (id) =>
  useApiFetcherSWR(
    id
      ? {
        ...API_ENDPOINT.WEEKSTAAT_DOWNLOAD,
        url: `document/${id}/weekstaat`,
      }
      : null
  );